/* global setTimeout, clearTimeout, setInterval, clearInterval, localStorage */
angular.module('kareo.ui.shared.modules.idleMonitor', ['kareo.ui.shared.modules.analytics']).provider('idleMonitor', function () {
  var options = {
    idleDuration: 720000, // 12 minutes (milliseconds)
    warningDuration: 180, // 3 minutes (seconds)
    events: 'mousemove keydown DOMMouseScroll mousewheel mousedown touchstart'
  };
  var idleCallBacks = {};
  var timers = {};
  var state = {
    idling: false, running: false, lastActive: null
  };
  this.$get = [
    '$document', function ($document) {
      function clearIdleTimer() {
        if (timers.idle) {
          clearTimeout(timers.idle);
        }
      }

      function clearWarningInterval() {
        if (timers.warning) {
          clearInterval(timers.warning);
        }
      }

      function writeToLocalStorage() {
        var lastPing = parseInt(localStorage.getItem('lastPing'));
        if (!lastPing || state.lastActive > lastPing) {
          localStorage.setItem('lastPing', state.lastActive);
        }
        if (timeTillIdle() > 1) {
          setTimeout(writeToLocalStorage, timeTillIdle() - 1);
        }
      }

      function warn() {
        if (state.countdown <= 0) {
          clearWarningInterval();
          idleCallBacks.timeOut();
        } else {
          idleCallBacks.warn(state.countdown);
        }
        state.countdown--;
      }

      function activeElsewhere(event) {
        if (event.key === 'lastPing' && event.newValue !== event.oldValue) {
          var lastPing = parseInt(event.newValue);
          if (lastPing > state.lastActive) {
            interrupt(lastPing);
          }
        }
      }

      function nowActive() {
        state.idling = false;
        renewIdleTimer();
        clearWarningInterval();
        writeToLocalStorage();
        idleCallBacks.end();
      }

      function timeTillIdle() {
        var idleFor = Date.now() - state.lastActive;
        return options.idleDuration - idleFor;
      }

      function nowIdle() {
        idleCallBacks.start();
        state.idling = true;
        state.countdown = options.warningDuration;
        warn();
        timers.warning = setInterval(warn, 1000);
      }

      function renewIdleTimer() {
        clearIdleTimer();
        timers.idle = setTimeout(nowIdle, timeTillIdle());
      }

      function interrupt(lastActive) {
        state.lastActive = lastActive;
        if (state.idling) {
          nowActive();
        } else {
          renewIdleTimer();
        }
      }

      function listenForActive() {
        function wrapInterrupt() {
          interrupt(Date.now());
        }

        $document.on(options.events, wrapInterrupt);
      }

      function listenForActiveTab() {
        if (window.addEventListener) {
          window.addEventListener('storage', activeElsewhere, false);
        } else {
          window.attachEvent('onstorage', activeElsewhere);
        }
      }

      function setIdleCallbacks(opts) {
        idleCallBacks.timeOut = opts.idleTimeOut || function () {
        };
        idleCallBacks.warn = opts.idleWarn || function () {
        };
        idleCallBacks.start = opts.idleStart || function () {
        };
        idleCallBacks.end = opts.idleEnd || function () {
        };
      }

      function initialize(opts) {
        if (!state.lastActive) {
          state.lastActive = Date.now();
          state.running = true;
          renewIdleTimer();
          writeToLocalStorage();
          listenForActive();
          listenForActiveTab();
          setIdleCallbacks(opts);
        }
      }

      function start(opts) {
        initialize(opts);
      }

      var svc = {
        _options() {
          return options;
        }, lastActive() {
          return state.lastActive;
        }, running() {
          return state.running;
        }, idling() {
          return state.idling;
        }, state() {
          return state;
        }, start
      };
      return svc;
    }];
});
